import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CameraRotateIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="cameraRotate" ref={ref} {...props}>
      <path d="M18.09,6.14H16.58c-.5,0-.68,0-.92-.62a2.27,2.27,0,0,0-2.29-1.6H10.66a2.26,2.26,0,0,0-2.29,1.6c-.24.57-.42.62-.92.62H5.94A2.83,2.83,0,0,0,3.25,9v8.76a2.85,2.85,0,0,0,2.84,2.84H17.91a2.84,2.84,0,0,0,2.84-2.84V9A2.83,2.83,0,0,0,18.09,6.14Zm1.16,11.59a1.34,1.34,0,0,1-1.34,1.34H6.09a1.34,1.34,0,0,1-1.34-1.34V9A1.34,1.34,0,0,1,6.09,7.63H7.45A2.24,2.24,0,0,0,9.75,6.1c.26-.61.42-.69.91-.69h2.71c.49,0,.65.08.91.69a2.24,2.24,0,0,0,2.3,1.53h1.36A1.34,1.34,0,0,1,19.25,9Zm-.81-6.39-.32.32-2.67,2.68-3-3h2.18a2.21,2.21,0,0,0-2.14-1.62,2.19,2.19,0,0,0-1.37.47A.75.75,0,1,1,10.19,9a3.73,3.73,0,0,1,6,2.33ZM14,16.2a3.73,3.73,0,0,1-6-2.33H5.77l.32-.31,2.68-2.68,3,3H9.58A2.24,2.24,0,0,0,13.1,15a.75.75,0,0,1,1.05.12A.76.76,0,0,1,14,16.2Z" />
    </Icon>
  ),
) as IconWithRender;

CameraRotateIcon.displayName = 'CameraRotateIcon';
CameraRotateIcon.renderIcon = (props) => <CameraRotateIcon {...props} />;
export default CameraRotateIcon;
